import React from 'react';
import { Outlet } from 'react-router-dom';
import { TourProvider } from './TourProvider';

export const TourLayout: React.FC = () => {
  return (
    <TourProvider>
      <Outlet />
    </TourProvider>
  );
};
